export default "__VITE_ASSET__CU426ClS__"